import React from 'react';
import { PasswordInput } from '@gravity-ui/components';
import { TextInput } from '@gravity-ui/uikit';
import isNil from 'lodash/isNil';
export const Text = ({ name, input: { value, onBlur, onChange, onFocus }, spec, inputProps, }) => {
    const props = Object.assign(Object.assign({ hasClear: true }, inputProps), { value: isNil(value) ? '' : `${value}`, onBlur: onBlur, onFocus: onFocus, onUpdate: onChange, disabled: spec.viewSpec.disabled, placeholder: spec.viewSpec.placeholder, qa: name });
    if (spec.viewSpec.type === 'password') {
        return (React.createElement(PasswordInput, Object.assign({}, props, { autoComplete: "new-password", showCopyButton: true, showRevealButton: true })));
    }
    return React.createElement(TextInput, Object.assign({}, props, { type: "text" }));
};
